import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const cameraCreateAtom = createMutationAtomFactory(
  'settings.cameraCreate',
  (params: {
    sidecarId: string;
    uniqueId: string;
    driverType: string;
    name: string;
    streamProfile: string;
    streamUrl?: string;
    snapshotUrl?: string;
  }) => ({
    iotCameraCreate: {
      __args: {
        input: {
          sidecarId: params.sidecarId,
          uniqueId: params.uniqueId,
          driverType: params.driverType,
          name: params.name,
          streamProfile: params.streamProfile,
          streamUrl: params.streamUrl,
          snapshotUrl: params.snapshotUrl,
        },
      },
      id: true,
      name: true,
      status: true,
      driverType: true,
    },
  }),
);
